import { Link } from "react-router-dom";
import { PageHeader, OwnerNote } from "../components/Layout";

const CONTENT = {
  privatliv: ["Privatlivspolitik", [
    ["Hvilke data behandler vi?", "Offentlige brugere kan søge uden at oprette konto. For klinikbrugere behandler vi navn, e-mail, krypteret adgangskode samt oplysninger i ejerskabsanmodninger. Henvendelser via kontaktformularen gemmes, så vi kan besvare dem."],
    ["Formål", "Data bruges til at administrere konti, verificere klinikejerskab, sikre platformen (bl.a. via auditlog) og besvare henvendelser."],
    ["Dine rettigheder", "Du kan anmode om indsigt, berigtigelse eller sletning af dine oplysninger ved at kontakte os. [Dataansvarlig og kontaktoplysninger indsættes]"],
  ]],
  vilkaar: ["Vilkår for brug", [
    ["Vejledende priser", "Priser på VetPris er vejledende. Den endelige pris aftales altid med klinikken."],
    ["Testversion", "VetPris er under opbygning og endnu ikke lanceret. Priser vises kun, når de er bekræftet af klinikken eller hentet fra en godkendt kilde."],
    ["Klinikkonti", "Klinikbrugere er ansvarlige for, at de indtastede oplysninger er korrekte. Ejerskab af en klinikprofil kræver godkendelse fra VetPris."],
  ]],
  cookies: ["Cookiepolitik", [
    ["Nødvendige cookies", "VetPris bruger kun nødvendige, sikre sessionscookies (httpOnly) til login. Der anvendes ingen sporings- eller markedsføringscookies i fase 1."],
  ]],
};

export default function Legal({ page }) {
  const [title, sections] = CONTENT[page];
  return (
    <div data-testid={`legal-page-${page}`}>
      <PageHeader eyebrow="Juridisk" title={title}>Udkast til fase 1 – skal gennemgås juridisk før lancering.</PageHeader>
      <div className="container-vp py-12 max-w-3xl space-y-8">
        <OwnerNote testid="legal-owner" />
        {sections.map(([h, t]) => <section key={h}><h2 className="text-xl font-bold text-[#153C3A]">{h}</h2><p className="text-[#334155] mt-2 leading-relaxed">{t}</p></section>)}
        <Link to="/kontakt" className="btn-outline" data-testid="legal-contact-link">Kontakt os</Link>
      </div>
    </div>
  );
}
